import React from 'react'
import { Drawer, Layout } from 'antd';
import styles from './index.module.scss'
// import BackLayout from '@/components/BackLayout/index';
import BackLayout from 'component/BackLayout';
import HeaderComponent from './header';
import SiderComponent from './sider';
import { useRedux } from 'redux/useRedux';
import { onChangePublic } from 'redux/actions/public';
import { Footer } from 'antd/es/layout/layout';
import FooterComponent from './footer';
const LayoutComponent = ({ children,...props }) => {
  const { publicState, dispatch } = useRedux()
  const { Header, Sider } = Layout;

  return (
    <BackLayout dashboard={true}>
      <Layout hasSider style={{ maxHeight: "100vh", width: '100%' }} >
        <Sider
        trigger={null}
          width={publicState?.sider_open ? 315 : 60}
            collapsed={!publicState?.sider_open}
          className={"customSider"}  >
          <SiderComponent />
        </Sider>
        <Drawer placement="right" className='menuMobile' onClose={() => dispatch(onChangePublic("drawer_open", false))} open={publicState?.drawer_open}>
          <SiderComponent />
        </Drawer>
        <Layout>
          <Header className={"customHeader"}>
            <HeaderComponent />
          </Header>
          <div className={styles.mainDiv} style={{padding:props?.ai?0:null}}>
            {children}

          </div>
        </Layout>
      </Layout>
    </BackLayout>
  )
}

export default LayoutComponent
